@if ({
  newsletterSubscription: newsletterSubscription$ | async,
  isAuthenticated: isAuthenticated$ | async,
}; as extracted) {
<div class="newsletter">
  <h4 class="header newsletter__header">Join our Newsletter</h4>

  @if (!extracted.newsletterSubscription) {
    @if (!sent) {
      @if (extracted.isAuthenticated) {
        <div class="button-wrap newsletter__button-wrap">
          <button class="b-button" type="submit" (click)="subscribeToNewsletter()">Subscribe</button>
        </div>
      } @else {
        <div [formGroup]="form" class="form newsletter__form">
          <div class="input newsletter__input">
            <rt-input-block
              name='email'
              class="rt-input newsletter__rt-input rt-input_hide-floating-label"
              [label]="formLabels['email']"
              [form]="form"
              [errors]="formErrors"
              placeholder="Email address"
            ></rt-input-block>
          </div>
          <div class="button-wrap newsletter__button-wrap">
            <button class="b-button" type="submit" (click)="submitForm()">
              Submit
            </button>
          </div>
        </div>
      }
    } @else {
      <div @fadeIn class="sent newsletter__sent">
        <p>Thank you for subscribing!</p>
      </div>
    }
  } @else {
    <div @fadeIn class="sent newsletter__sent">
      @if (!extracted.newsletterSubscription?.unsubscribed) {
        <p>
          Thank you for subscribing!
        </p>
      } @else {
        <div class="button-wrap newsletter__button-wrap">
          <button class="b-button" type="submit" (click)="resubscribeToNewsletter()">Subscribe</button>
        </div>
      }
    </div>
  }

</div>
@if (error !== null) {
  <div @fadeIn class="error newsletter__error">{{ error }}</div>
}
}
